export enum MessageStatus {
  New = 1,
  Read = 2,
  Archived = 3
}
